import {gql} from "@apollo/client";
import {AuthReviewNeededInput} from "../../domain";
import {getDomainGraphqlError, useMutation$} from "graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";
import {format} from "date-fns-tz";
import {LOCAL_DATE_FORMAT} from "common";

const GRAPHQL_MUTATION = gql`
mutation submitAuthReviewNeeded($input: AuthReviewNeededInput) {
    submitAuthReviewNeeded(input: $input) {
        guid
    }
}`;

type AuthAuthReviewNeededInput = Omit<AuthReviewNeededInput, 'authReviewFromDate' | 'authReviewToDate' | 'requestedExtensionDate' | 'firstScheduledAssessment'> & {
    authorizationGuid: string;
    authReviewFromDate?: string;
    authReviewToDate?: string;
    requestedExtensionDate?: string;
    firstScheduledAssessment?: string;
}

const sanitizePayload = (formValues: AuthReviewNeededInput) => {
    return { 
        ...formValues,
        authReviewFromDate: formValues.authReviewFromDate ? format(new Date(formValues.authReviewFromDate), LOCAL_DATE_FORMAT) : undefined,
        authReviewToDate: formValues.authReviewToDate ? format(new Date(formValues.authReviewToDate), LOCAL_DATE_FORMAT) : undefined,
        requestedExtensionDate: formValues.requestedExtensionDate ? format(new Date(formValues.requestedExtensionDate), LOCAL_DATE_FORMAT) : undefined,
        firstScheduledAssessment: formValues.firstScheduledAssessment ? format(new Date(formValues.firstScheduledAssessment), LOCAL_DATE_FORMAT) : undefined,
    }
}

export function useAuthReviewNeeded(authorizationGuid: string) {
    const {execute,} = useMutation$<{ input: AuthAuthReviewNeededInput }, void>(GRAPHQL_MUTATION);
    const submitAuthReviewNeeded = useCallback(async function (formValues: AuthReviewNeededInput | null) {
        if (formValues == null) {
            return;
        }

        try {
            await execute({
                variables: {
                            input: {
                        ...sanitizePayload(formValues),
                        authorizationGuid,
                    },
                }
            });
            showToast.success(
                'Auth Review needed request successfully submitted. The Request can be tracked in the "Submitted Requests" section and a request number ID will be available shortly.'
            );
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to submit reason by ${errors.message || errors[0].message}`);
            }
        }
    }, [authorizationGuid, execute]);

    return {
        submitAuthReviewNeeded
    }
}
